module.exports = __webpack_public_path__ + "img/20200912_130925.92de54c3.jpg";